export default __webpack_public_path__ + "static/image06-4fcc9e69a75125e4f9c337c0dd2aa288.webp";